import api from "./api";

export const forgotPassword = async (identifier) => {
    const { data } = await api.post("/password/forgot", {
        identifier,
    });

    return data;
};

export const verifyRecoveryCode = async (code) => {
    const { data } = await api.post("/password/verify-code", {
        code,
    });

    return data;
};

export const resetPassword = async (code, newPassword) => {
    const { data } = await api.post("/password/reset", {
        code,
        newPassword,
    });

    return data;
};

export const generateRefreshToken = async (userId) => {
    const { data } = await api.post(`/RefreshToken/${userId}/generate`);
    return data;
};

export default {
    forgotPassword,
    verifyRecoveryCode,
    resetPassword,
    generateRefreshToken,
};